var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1333 2.53472C14.5695 2.65259 14.8724 3.04828 14.8724 3.50009V10.0001H17.75C18.1076 10.0001 18.438 10.191 18.6165 10.5009C18.795 10.8108 18.7945 11.1924 18.6151 11.5017L12.5267 22.0017C12.2998 22.393 11.8386 22.5833 11.4018 22.4658C10.9651 22.3483 10.6616 21.9524 10.6616 21.5001V15.0001H7.75C7.39197 15.0001 7.06125 14.8087 6.8829 14.4983C6.70455 14.1878 6.70578 13.8057 6.88613 13.4964L13.0086 2.99637C13.2362 2.60607 13.6972 2.41685 14.1333 2.53472ZM9.49067 13.0001H11.6616C12.2139 13.0001 12.6616 13.4478 12.6616 14.0001V17.782L16.0142 12.0001H13.8724C13.3202 12.0001 12.8724 11.5524 12.8724 11.0001V7.20034L9.49067 13.0001Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.bf168e1b9aa591c2be2522002a6a916e.svg";
export { ForwardRef as ReactComponent };